import { DateTime } from 'luxon';

export const formatConversationDate = (
  value: string,
  locale: string,
  now = DateTime.local(),
): string => {
  const date = DateTime.fromISO(value).toLocal().setLocale(locale);
  if (!date.isValid) return '';
  const time = date.toFormat('h:mma').toLowerCase();
  if (date.hasSame(now.minus({ days: 1 }), 'day')) {
    const yesterday = new Intl.RelativeTimeFormat(locale, {
      numeric: 'auto',
    }).format(-1, 'day');
    return `${yesterday.charAt(0).toUpperCase()}${yesterday.slice(1)}, ${time}`;
  }
  const daysAgo = now.startOf('day').diff(date.startOf('day'), 'days').days;
  return `${date.toFormat(daysAgo >= 0 && daysAgo < 7 ? 'cccc' : 'LLL d')}, ${time}`;
};
